import { rankingCards } from '../../../../mocks/ranking-cards';

export default function SelectionGuide() {
  // Get free annual fee cards
  const freeCards = rankingCards.filter(card => card.annualFee === '永年無料').slice(0, 3);

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-6xl mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-[#003366] mb-12">
          年会費無料カードの選び方
        </h2>

        <div className="grid md:grid-cols-3 gap-8 mb-12">
          <div className="bg-white rounded-xl shadow-lg p-8">
            <div className="w-16 h-16 bg-[#FF9900] rounded-full flex items-center justify-center mb-6 mx-auto">
              <i className="ri-percent-line text-white text-3xl w-8 h-8 flex items-center justify-center"></i>
            </div>
            <h3 className="text-xl font-bold text-[#003366] mb-4 text-center">還元率で選ぶ</h3>
            <p className="text-gray-700 text-center">
              年会費無料でも1.0%以上の高還元率カードがあります。日常使いでポイントを効率的に貯めましょう。
            </p>
          </div>

          <div className="bg-white rounded-xl shadow-lg p-8">
            <div className="w-16 h-16 bg-[#FF9900] rounded-full flex items-center justify-center mb-6 mx-auto">
              <i className="ri-store-line text-white text-3xl w-8 h-8 flex items-center justify-center"></i>
            </div>
            <h3 className="text-xl font-bold text-[#003366] mb-4 text-center">利用店舗で選ぶ</h3>
            <p className="text-gray-700 text-center">
              よく利用する店舗やサービスで高還元率になるカードを選ぶと、さらにお得にポイントが貯まります。
            </p>
          </div>

          <div className="bg-white rounded-xl shadow-lg p-8">
            <div className="w-16 h-16 bg-[#FF9900] rounded-full flex items-center justify-center mb-6 mx-auto">
              <i className="ri-gift-line text-white text-3xl w-8 h-8 flex items-center justify-center"></i>
            </div>
            <h3 className="text-xl font-bold text-[#003366] mb-4 text-center">特典で選ぶ</h3>
            <p className="text-gray-700 text-center">
              入会キャンペーンや付帯保険、優待サービスなど、カードごとの特典を比較して選びましょう。
            </p>
          </div>
        </div>

        <h3 className="text-2xl font-bold text-[#003366] mb-8 text-center">おすすめの年会費無料カード</h3>

        <div className="grid md:grid-cols-3 gap-8">
          {freeCards.map((card, index) => (
            <div
              key={card.id}
              className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow overflow-hidden"
            >
              <div className="w-full h-48 flex items-center justify-center bg-gray-50 p-6">
                <img
                  src={card.logo}
                  alt={card.name}
                  className="w-full h-full object-contain"
                />
              </div>

              <div className="p-6">
                <h4 className="text-xl font-bold text-[#003366] mb-4">{card.name}</h4>

                <div className="space-y-3 mb-6">
                  <div className="flex justify-between items-center">
                    <span className="text-sm text-gray-600">還元率</span>
                    <span className="text-lg font-bold text-[#FF9900]">{card.returnRate}</span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-sm text-gray-600">年会費</span>
                    <span className="text-lg font-bold text-[#003366]">{card.annualFee}</span>
                  </div>
                </div>

                <div className="space-y-3">
                  <a
                    href={card.officialUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block w-full bg-[#FF9900] hover:bg-[#E68A00] text-white font-bold px-6 py-3 rounded-lg transition-all text-center cursor-pointer whitespace-nowrap"
                  >
                    公式サイトを見る
                  </a>
                  <a
                    href={card.detailUrl}
                    className="block w-full bg-white hover:bg-gray-50 text-[#003366] font-bold px-6 py-3 rounded-lg border-2 border-[#003366] transition-all text-center cursor-pointer whitespace-nowrap"
                  >
                    詳細を見る
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
